import React, { useEffect, useRef, useState } from 'react';
import downloadSkinZip from './downloadSkinZip';
import { fontFetcher } from './fontFetcher';
import CanvasElements from './canvasElements';
import MockMain from './skin-components/MockMain.js';
import BMP20128 from './skin-components/BMP20128';
import BMP20148 from './skin-components/BMP20148';
import BMP20138 from './skin-components/BMP20138';
import BMP20149 from './skin-components/BMP20149';
import BMP20135 from './skin-components/BMP20135';
import BMP20151 from './skin-components/BMP20151';
import BMP20159 from './skin-components/BMP20159';
import BMP20164 from './skin-components/BMP20164';
import BMP20165 from './skin-components/BMP20165';
import BMP20166 from './skin-components/BMP20166';
import BMP20167 from './skin-components/BMP20167';
import BMP20168 from './skin-components/BMP20168';
import BMP20172 from './skin-components/BMP20172';
import BMP20173 from './skin-components/BMP20173';
import BMP20174 from './skin-components/BMP20174';
import BMP20175 from './skin-components/BMP20175';
import BMP20176 from './skin-components/BMP20176';
import BMP20177 from './skin-components/BMP20177';
import BMP20178 from './skin-components/BMP20178';
import BMP20179 from './skin-components/BMP20179';
import BMP20180 from './skin-components/BMP20180';
import BMP20181 from './skin-components/BMP20181';
import BMP20182 from './skin-components/BMP20182';
import BMP20183 from './skin-components/BMP20183';
import BMP20198 from './skin-components/BMP20198';
import BMP20199 from './skin-components/BMP20199';
import BMP20200 from './skin-components/BMP20200';
import BMP20201 from './skin-components/BMP20201';
import BMP20211 from './skin-components/BMP20211';
import BMP20257 from './skin-components/BMP20257';
import BMP20269 from './skin-components/BMP20269';
import BMP20265 from './skin-components/BMP20265';
import BMP20266 from './skin-components/BMP20266';
import BMP20270 from './skin-components/BMP20270';
import BMP20274 from './skin-components/BMP20274';
import BMP20169 from './skin-components/BMP20169';
import BMP20170 from './skin-components/BMP20170';
import BMP20171 from './skin-components/BMP20171';
import BMP20129 from './skin-components/BMP20129';
import BMP20143 from './skin-components/BMP20143';
import BMP20155 from './skin-components/BMP20155';
import BMP20208 from './skin-components/BMP20208';
import BMP20262 from './skin-components/BMP20262';
import BMP20222 from './skin-components/BMP20222';
import BMP20161 from './skin-components/BMP20161';
import BMP20232 from './skin-components/BMP20232';
import BMP20260 from './skin-components/BMP20260';
import BMP20154 from './skin-components/BMP20154';
import BMP20273 from './skin-components/BMP20273';
import BMP20130 from './skin-components/BMP20130';
import BMP20145 from './skin-components/BMP20145';
import BMP20157 from './skin-components/BMP20157';
import BMP20163 from './skin-components/BMP20163';
import BMP20219 from './skin-components/BMP20219';
import BMP20223 from './skin-components/BMP20223';
import BMP20224 from './skin-components/BMP20224';
import BMP20241 from './skin-components/BMP20241';
import BMP20240 from './skin-components/BMP20240';
import BMP20131 from './skin-components/BMP20131';
import BMP20133 from './skin-components/BMP20133';
import BMP20137 from './skin-components/BMP20137';
import BMP20213 from './skin-components/BMP20213';
import BMP20216 from './skin-components/BMP20216';
import BMP20256 from './skin-components/BMP20256';
import BMP20267 from './skin-components/BMP20267';
import BMP20136 from './skin-components/BMP20136';
import BMP20210 from './skin-components/BMP20210';
import BMP20220 from './skin-components/BMP20220';
import BMP20184 from './skin-components/BMP20184';
import BMP20142 from './skin-components/BMP20142';
import BMP20160 from './skin-components/BMP20160';
import BMP20150 from './skin-components/BMP20150';
import BMP20153 from './skin-components/BMP20153';
import BMP20156 from './skin-components/BMP20156';
import BMP20202 from './skin-components/BMP20202';
import BMP20197 from './skin-components/BMP20197';
import BMP20204 from './skin-components/BMP20204';
import BMP20239 from './skin-components/BMP20239';
import BMP20243 from './skin-components/BMP20243';
import BMP20268 from './skin-components/BMP20268';
import BMP20242 from './skin-components/BMP20242';
import BMP20226 from './skin-components/BMP20226';
import BMP20225 from './skin-components/BMP20225';
import BMP20158 from './skin-components/BMP20158';
import BMP20205 from './skin-components/BMP20205';
import BMP20193 from './skin-components/BMP20193';
import BMP20192 from './skin-components/BMP20192';
import BMP20191 from './skin-components/BMP20191';
import BMP20190 from './skin-components/BMP20190';
import BMP20189 from './skin-components/BMP20189';
import BMP20188 from './skin-components/BMP20188';
import BMP20187 from './skin-components/BMP20187';
import BMP20186 from './skin-components/BMP20186';
import BMP20185 from './skin-components/BMP20185';
import BMP20194 from './skin-components/BMP20194';
import BMP20207 from './skin-components/BMP20207';
import BMP20144 from './skin-components/BMP20144';
import BMP20209 from './skin-components/BMP20209';
import BMP20146 from './skin-components/BMP20146';

import ColorMap from './skin-components/ColorMap';
import { otfFetch } from './otfFetch';
import UserInterface from './User-Interface';
import ViewSelect from './ui-components/viewSelect';
import ExportMenu from './ui-components/exportMenu';
import Zoom from './ui-components/zoom';
import Header from './Header';

let svgComponentArray = [];

function Skins() {
    const canvasBmp128 = useRef();
    const canvasBmp138 = useRef();
    const canvasBmp148 = useRef();
    const canvasBmp149 = useRef();
    const canvasBmp135 = useRef();
    const canvasBmp151 = useRef();
    const canvasBmp159 = useRef();
    const canvasBmp164 = useRef();
    const canvasBmp165 = useRef();
    const canvasBmp166 = useRef();
    const canvasBmp167 = useRef();
    const canvasBmp168 = useRef();
    const canvasBmp172 = useRef();
    const canvasBmp173 = useRef();
    const canvasBmp174 = useRef();
    const canvasBmp175 = useRef();
    const canvasBmp176 = useRef();
    const canvasBmp177 = useRef();
    const canvasBmp178 = useRef();
    const canvasBmp179 = useRef();
    const canvasBmp180 = useRef();
    const canvasBmp181 = useRef();
    const canvasBmp182 = useRef();
    const canvasBmp183 = useRef();
    const canvasBmp198 = useRef();
    const canvasBmp199 = useRef();
    const canvasBmp200 = useRef();
    const canvasBmp201 = useRef();
    const canvasBmp211 = useRef();
    const canvasBmp257 = useRef();
    const canvasBmp269 = useRef();
    const canvasBmp265 = useRef();
    const canvasBmp266 = useRef();
    const canvasBmp270 = useRef();
    const canvasBmp274 = useRef();
    const canvasBmp169 = useRef();
    const canvasBmp170 = useRef();
    const canvasBmp171 = useRef();
    const canvasBmp129 = useRef();
    const canvasBmp143 = useRef();
    const canvasBmp155 = useRef();
    const canvasBmp208 = useRef();
    const canvasBmp262 = useRef();
    const canvasBmp222 = useRef();
    const canvasBmp161 = useRef();
    const canvasBmp232 = useRef();
    const canvasBmp260 = useRef();
    const canvasBmp154 = useRef();
    const canvasBmp273 = useRef();
    const canvasBmp130 = useRef();
    const canvasBmp145 = useRef();
    const canvasBmp157 = useRef();
    const canvasBmp163 = useRef();
    const canvasBmp219 = useRef();
    const canvasBmp223 = useRef();
    const canvasBmp224 = useRef();
    const canvasBmp241 = useRef();
    const canvasBmp240 = useRef();
    const canvasBmp131 = useRef();
    const canvasBmp133 = useRef();
    const canvasBmp137 = useRef();
    const canvasBmp213 = useRef();
    const canvasBmp216 = useRef();
    const canvasBmp256 = useRef();
    const canvasBmp267 = useRef();
    const canvasBmp136 = useRef();
    const canvasBmp210 = useRef();
    const canvasBmp220 = useRef();
    const canvasBmp184 = useRef();
    const canvasBmp142 = useRef();
    const canvasBmp160 = useRef();
    const canvasBmp150 = useRef();
    const canvasBmp153 = useRef();
    const canvasBmp156 = useRef();
    const canvasBmp202 = useRef();
    const canvasBmp197 = useRef();
    const canvasBmp242 = useRef();
    const canvasBmp268 = useRef();
    const canvasBmp243 = useRef();
    const canvasBmp239 = useRef();
    const canvasBmp204 = useRef();
    const canvasBmp226 = useRef();
    const canvasBmp225 = useRef();
    const canvasBmp158 = useRef();
    const canvasBmp205 = useRef();
    const canvasBmp193 = useRef();
    const canvasBmp192 = useRef();
    const canvasBmp191 = useRef();
    const canvasBmp190 = useRef();
    const canvasBmp189 = useRef();
    const canvasBmp188 = useRef();
    const canvasBmp187 = useRef();
    const canvasBmp186 = useRef();
    const canvasBmp185 = useRef();
    const canvasBmp194 = useRef();
    const canvasBmp207 = useRef();
    const canvasBmp144 = useRef();
    const canvasBmp209 = useRef();
    const canvasBmp146 = useRef();

    const canvasColorMap = useRef();
    // having one fontFace object with data and name props is extremely slow.
    const [fontChoice, setFontChoice] = useState("0");
    const [fontFace, setFontFace] = useState("");
    const [fontName, setFontName] = useState("");
    const [fontData, setFontData] = useState("");
    const [fontColour, setFontColour] = useState("#fafafa");
    const [fontExtras, setFontExtras] = useState({ space: "0em", weight: "800" });
    // const [fontSpace, setFontSpace] = useState("0em");
    const [backgroundFill, setBackgroundFill] = useState("#8a8a8a");
    // const [backgroundFill, setBackgroundFill] = useState("url(#image1)");
    const [highlightColour, setHighlightColour] = useState("#ee655d");
    const [highlightColourB, setHighlightColourB] = useState("#ee655d");
    const [darkFill, setDarkFill] = useState("#836767");
    const [envFill, setEnvFill] = useState("#2eff35");
    // const [backgroundFillB, setBackgroundFillB] = useState("rgb(255, 136, 100)");
    const [paramFill, setParamFill] = useState("#4a4a4a");
    const [waveBG, setWaveBG] = useState("#7a70ff");
    const [envBG, setEnvBG] = useState("#000000");
    // const [headingBG, setHeadingBG] = useState("rgb(255, 136, 100)");
    const [knobColour, setKnobColour] = useState("#ec2727");
    const [outlineColour, setOutlineColour] = useState("black");
    const [main, setMain] = useState("block");
    const [fx, setFx] = useState("none");
    const [matrix, setMatrix] = useState("none");
    const [global, setGlobal] = useState("none");
    const [wtEditor, setWtEditor] = useState("none");
    const [preset, setPreset] = useState("none");
    // const [unassigned, setUnassigned] = useState("none");
    const [zoom, setZoom] = useState({ transform: "scale(0.3)", marginLeft: "0px", marginTop: "0px" });
    const [statusDisplay, setStatusDisplay] = useState("none");
    const [resolutionSize, setResolutionSize] = useState(1);
    // const [gradient1, setGradient1] = useState(
    //     `<defs>
    //     <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
    //     <stop offset="30%" style="stop-color:yellow;stop-opacity:1" />
    //     <stop offset="100%" style="stop-color:red;stop-opacity:1" />
    //     </linearGradient>
    //     </defs>`);
    const [image1, setImage1] = useState("");
    const image1Fill = "url(#image1)"
    // const [image1Fill, setImage1Fill] = useState("url(#image1)");
    // const [textStyle, settextStyle] = useState(`text-shadow: 2px 2px 3px #000000`);
    const [styledText, setStyledText] = useState("");
    const [boxStyle, setBoxStyle] = useState("");
    const [shadowColour, setShadowColour] = useState("#000000");
    const [radiation, setRadiation] = useState(`filter: drop-shadow( 0px 0px 8px #ee655d);`);
    const [keysColourA, setKeysColourA] = useState("#ffffff");
    const [keysColourB, setKeysColourB] = useState("#000000");
    const [logoHide, setLogoHide] = useState("block");
    // const [modOutsideColour, setModOutsideColour] = useState("#000000");
    // const [modInsideColour, setModInsideColour] = useState("#444444");

    // drop-shadow(0px 0px 10px rgba(255,255,255,0.5))

    // this seems to be required for font to download if left as default
    useEffect(() => {
        otfFetch(0, setFontData);
    }, [])

    useEffect(() => {
        fontFetcher(fontChoice, setFontFace, setFontName);
        otfFetch(fontChoice, setFontData);
    }, [fontChoice])

    useEffect(() => {
        setHighlightColourB(paramFill);
    }, [paramFill])

    useEffect(() => {
        setRadiation(`filter: drop-shadow( 0px 0px 8px ${highlightColour});`);
    }, [highlightColour])

    const canvasBmpArray = [
        canvasColorMap,
        canvasBmp128,
        canvasBmp138,
        canvasBmp148,
        canvasBmp149,
        canvasBmp135,
        canvasBmp151,
        canvasBmp159,
        canvasBmp164,
        canvasBmp165,
        canvasBmp166,
        canvasBmp167,
        canvasBmp168,
        canvasBmp172,
        canvasBmp173,
        canvasBmp174,
        canvasBmp175,
        canvasBmp176,
        canvasBmp177,
        canvasBmp178,
        canvasBmp179,
        canvasBmp180,
        canvasBmp181,
        canvasBmp182,
        canvasBmp183,
        canvasBmp198,
        canvasBmp199,
        canvasBmp200,
        canvasBmp201,
        canvasBmp257,
        canvasBmp269,
        canvasBmp211,
        canvasBmp265,
        canvasBmp266,
        canvasBmp270,
        canvasBmp274,
        canvasBmp169,
        canvasBmp170,
        canvasBmp171,
        canvasBmp129,
        canvasBmp143,
        canvasBmp155,
        canvasBmp208,
        canvasBmp262,
        canvasBmp222,
        canvasBmp161,
        canvasBmp232,
        canvasBmp260,
        canvasBmp154,
        canvasBmp273,
        canvasBmp130,
        canvasBmp145,
        canvasBmp157,
        canvasBmp163,
        canvasBmp219,
        canvasBmp223,
        canvasBmp224,
        canvasBmp241,
        canvasBmp240,
        canvasBmp131,
        canvasBmp133,
        canvasBmp137,
        canvasBmp213,
        canvasBmp216,
        canvasBmp256,
        canvasBmp267,
        canvasBmp136,
        canvasBmp210,
        canvasBmp220,
        canvasBmp184,
        canvasBmp142,
        canvasBmp160,
        canvasBmp150,
        canvasBmp153,
        canvasBmp156,
        canvasBmp202,
        canvasBmp197,
        canvasBmp242,
        canvasBmp268,
        canvasBmp243,
        canvasBmp239,
        canvasBmp204,
        canvasBmp226,
        canvasBmp225,
        canvasBmp158,
        canvasBmp205,
        canvasBmp193,
        canvasBmp192,
        canvasBmp191,
        canvasBmp190,
        canvasBmp189,
        canvasBmp188,
        canvasBmp187,
        canvasBmp186,
        canvasBmp185,
        canvasBmp194,
        canvasBmp207,
        canvasBmp144,
        canvasBmp209,
        canvasBmp146
    ]

    function svgReturn(index, svg, name, width, height) {
        let svgHashRemoved = svg.replace(/#/g, "%23");
        let name2x = name.replace("bmp0", "bmp2");

        svgComponentArray[index] = ({ data: `data:image/svg+xml;utf8,${svgHashRemoved}`, fileName: name, fileName2x: name2x, width: width, height: height });
    }

    // possibly move this to another file
    function svgToCanvas(size) {
        for (let i = 0; i < canvasBmpArray.length; i++) {
            let canvasObj = canvasBmpArray[i].current;
            let ctx = canvasObj.getContext('2d');
            ctx.clearRect(0, 0, canvasObj.width, canvasObj.height);
            ctx.imageSmoothingEnabled = false;
            let svgImage = new Image();
            svgImage.src = svgComponentArray[i].data;
            svgImage.onload = () => {
                if (size === 1) {
                    ctx.drawImage(svgImage, 0, 0, (svgComponentArray[i].width / 2), (svgComponentArray[i].height / 2));
                }
                else {
                    svgComponentArray[0].width = 16;
                    svgComponentArray[0].height = 9;
                    ctx.drawImage(svgImage, 0, 0, (svgComponentArray[i].width), (svgComponentArray[i].height));
                }
                // ctx.drawImage(svgImage, 0, 0, (svgComponentArray[0].width / 2), (svgComponentArray[0].height / 2)) 
            }
        }
    }

    function handleDownload(skinName, size) {
        setResolutionSize(parseInt(size));
        otfFetch(fontChoice, setFontData);
        svgToCanvas(size);
        setStatusDisplay("block");
        // allow time for canvas' to render before downloading
        setTimeout(() => downloadSkinZip(canvasBmpArray, svgComponentArray, fontData, fontName, skinName, size), 4000);
        setTimeout(() => setStatusDisplay("none"), 5000);
    }

    return (
        <div>
            <Header />
            <div className="view">
                <UserInterface
                    setFontChoice={setFontChoice}
                    setFontExtras={setFontExtras} fontExtras={fontExtras}
                    setStyledText={setStyledText}
                    setBoxStyle={setBoxStyle}
                    // setFontSpace = {setFontSpace} fontSpace={fontSpace}
                    setFontName={setFontName}
                    setBackgroundFill={setBackgroundFill} backgroundFill="#8a8a8a"
                    setFontColour={setFontColour} fontColour="#fafafa"
                    setHighlightColour={setHighlightColour} highlightColour="#ee655d"
                    setDarkFill={setDarkFill} darkFill="#836767"
                    setEnvFill={setEnvFill} envFill="#2eff35"
                    setWaveBG={setWaveBG} waveBG="#7a70ff"
                    setParamFill={setParamFill} paramFill="#4a4a4a"
                    setKnobColour={setKnobColour} knobColour="#ec2727"
                    setOutlineColour={setOutlineColour} outlineColour="#000000"
                    setEnvBG={setEnvBG} envBG="#000000"
                    setShadowColour={setShadowColour} shadowColour={shadowColour}
                    setImage1={setImage1}
                    setKeysColourA={setKeysColourA} keysColourA="#ffffff"
                    setKeysColourB={setKeysColourB} keysColourB="#000000"
                    setLogoHide={setLogoHide} logoHide={logoHide}
                // setModOutsideColour={setModOutsideColour} modOutsideColour="#000000"
                // setModInsideColour={setModInsideColour} modInsideColour="#444444"
                />
                <div className="previewContainer">
                    <div className="zoomer">
                        <Zoom setZoom={setZoom} zoom={zoom} />
                    </div>
                    <div className="livePreview" style={zoom}>
                        <div className="main" style={{ display: main }}>
                            <BMP20128 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill}
                                fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} waveBG={waveBG} outlineColour={outlineColour} styledText={styledText}
                                boxStyle={boxStyle} image1={image1} image1Fill={image1Fill} keysColourA={keysColourA} keysColourB={keysColourB} logoHide={logoHide} />
                            <BMP20159 radiation={radiation} styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20164 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20165 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20166 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20222 svgReturn={svgReturn} fontColour={fontColour} knobColour={knobColour} />
                            <BMP20161 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20130 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20137 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20216 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20256 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20220 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20142 svgReturn={svgReturn} fontColour={fontColour} darkFill={darkFill} />
                            <BMP20197 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20226 svgReturn={svgReturn} fontColour={fontColour} envBG={envBG} />
                            <BMP20225 svgReturn={svgReturn} envBG={envBG} />
                            <BMP20158 svgReturn={svgReturn} envBG={envBG} />
                            {/* <BMP20214 svgReturn={svgReturn} modOutsideColour={modOutsideColour} modInsideColour={modInsideColour} /> */}
                            <MockMain waveBG={waveBG} envFill={envFill} />
                        </div>
                        <div className="global" style={{ display: global }}>
                            <BMP20204 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} highlightColourB={highlightColourB} paramFill={paramFill} outlineColour={outlineColour} />
                        </div>
                        <div className="wtEditor" style={{ display: wtEditor }}>
                            <BMP20239 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} highlightColourB={highlightColourB} paramFill={paramFill} />
                        </div>
                        <div className="matrix" style={{ display: matrix }}>
                            <BMP20243 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} highlightColourB={highlightColourB} paramFill={paramFill} />
                        </div>
                        <div className="preset" style={{ display: preset }}>
                            <BMP20268 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} highlightColourB={highlightColourB} paramFill={paramFill} />
                        </div>
                        <div className="matrix" style={{ display: matrix }}>
                            <BMP20242 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} highlightColourB={highlightColourB} paramFill={paramFill} />
                        </div>
                        <div className="fx" style={{ display: fx }}>
                            <BMP20205 boxStyle={boxStyle} styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20193 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20192 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20191 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20190 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20189 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20188 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20187 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20186 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20185 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20194 boxStyle={boxStyle} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} paramFill={paramFill} outlineColour={outlineColour} />
                            <BMP20207 svgReturn={svgReturn} backgroundFill={backgroundFill} paramFill={paramFill} />
                        </div>
                        <div style={{ display: "none" }}>
                            <BMP20148 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} />
                            <BMP20149 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} />
                            <BMP20135 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} paramFill={paramFill} />
                            <BMP20151 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} />
                            <BMP20138 radiation={radiation} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20167 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20168 svgReturn={svgReturn} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20172 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20173 styledText={styledText} svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20174 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20175 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20176 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20177 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20178 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20179 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20180 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20181 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20182 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20183 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20198 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20199 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20200 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20201 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20211 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} />
                            <BMP20257 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} darkFill={darkFill} />
                            <BMP20269 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} darkFill={darkFill} />
                            <BMP20265 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} paramFill={paramFill} />
                            <BMP20266 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20270 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20274 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} paramFill={paramFill} />
                            <BMP20169 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} styledText={styledText} />
                            <BMP20170 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} fontColour={fontColour} styledText={styledText} />
                            <BMP20171 svgReturn={svgReturn} fontColour={fontColour} />
                            <BMP20129 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20143 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20155 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20208 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20262 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20232 radiation={radiation} svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20260 svgReturn={svgReturn} fontColour={fontColour} knobColour={knobColour} />
                            <BMP20154 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20273 svgReturn={svgReturn} highlightColour={highlightColour} />
                            <BMP20145 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20157 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20163 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20219 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20223 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20224 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20241 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20240 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20131 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20133 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20213 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20267 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20136 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20210 svgReturn={svgReturn} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20184 svgReturn={svgReturn} fontColour={fontColour} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} />
                            <BMP20160 svgReturn={svgReturn} />
                            <BMP20150 svgReturn={svgReturn} backgroundFill={backgroundFill} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20153 svgReturn={svgReturn} backgroundFill={backgroundFill} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20156 svgReturn={svgReturn} backgroundFill={backgroundFill} darkFill={darkFill} highlightColour={highlightColour} />
                            <BMP20202 svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} backgroundFill={backgroundFill} fontColour={fontColour} highlightColour={highlightColour} />
                            <BMP20144 svgReturn={svgReturn} fontColour={fontColour} />
                            <BMP20209 svgReturn={svgReturn} fontColour={fontColour} />
                            <BMP20146 svgReturn={svgReturn} paramFill={paramFill} />
                            <ColorMap svgReturn={svgReturn} fontFace={fontFace} fontName={fontName} fontExtras={fontExtras} envFill={envFill} backgroundFill={backgroundFill} fontColour={fontColour} darkFill={darkFill} highlightColour={highlightColour} waveBG={waveBG} />
                        </div>
                    </div>
                </div>
                <div className="components">
                    <ViewSelect setMain={setMain} setFx={setFx} setMatrix={setMatrix} setGlobal={setGlobal} setWtEditor={setWtEditor} setPreset={setPreset} />
                    <ExportMenu handleDownload={handleDownload} />
                </div>
                <div style={{ display: statusDisplay }} className="coverPage">
                    <div style={{ display: statusDisplay }} className="status">Preparing Download. Please Wait.</div>
                </div>
                {/* <button onClick={handleDownload}>Download Skin</button>
            <button onClick={() => { downloadSkinZip(canvasBmpArray, svgComponentArray, fontData, fontName) }}>download button</button>
            <button onClick={() => svgToCanvas()}>SVG to Canvas (Preview)</button>
            <button onClick={() => otfFetch(fontChoice, setFontData)}>Console Logging</button> */}
                {/* <button onClick={() => console.log(fontName, fontChoice)}>Console Logging</button> */}
                <div style={{ width: "0", height: "0", overflow: "hidden" }}>
                    {/* <div style={{ width: "1000", height: "1000" }}> */}
                    <CanvasElements canvasBmpArray={canvasBmpArray} svgComponentArray={svgComponentArray} resolutionSize={resolutionSize} />
                </div>
            </div>
        </div>
    )
}

export default Skins;